module.exports = __webpack_public_path__ + "img/2014nianhui.9bf1aa30.png";